import {supabase} from '../../supabase.client';
import supabaseErrorCodeDictionnary from '@/lib/supabaseErrorCodeDictionnary';
const useExperienceApi = () => {
  const searchExperiences = async (searchTerm) => {
    try {
      const { data, error } = await supabase
      .from('experiences')
      .select('*')
      .ilike('objective', `%${searchTerm}%`);
      if (error) {
        throw (error)
      } else {
        return data || []
      }
    } catch (error) {
      console.error(error);
      return []
    }
  };
  const searchPersonaExperienceGroups = async (searchTerm) => {
    try {
      const { data, error } = await supabase
      .from('persona_experience_group')
      .select('*')
      .ilike('name', `%${searchTerm}%`);
      if (error) {
        throw (error)
      } else {
        return data || []
      }
    } catch (error) {
      console.error(error);
      return []
    }
  };
  const searchProductExperienceGroups = async (searchTerm) => {
    try {
      const { data, error } = await supabase
      .from('product_experience_group')
      .select('*')
      .ilike('name', `%${searchTerm}%`);
      if (error) {
        throw (error)
      } else {
        return data || []
      }
    } catch (error) {
      console.error(error);
      return []
    }
  };
  const insertExperience = async (objective) => {
    try {
      const {data, error} = await supabase
        .from('experiences')
        .insert({objective})
        .select()
        .single();
      if(data) {
        return data; 
      } else if (error) {
        throw error
      }
    } catch (e) {
      console.error(e);
      throw e; 
    }
  };
  const insertExperienceGroupInProduct = async (name, productId, groupId) => {
    try {
      const {data, error} = await supabase.rpc('create_product_experience_group', {
        arg_name: name,
        arg_product_id: productId,
        arg_parent_group_id: groupId
      });
      if(data) {
        return data; 
      } else if (error) {
        console.error('❌ DEBUG: insertExperienceGroupInProduct error:', error);
        throw error
      }
    } catch (e) {
      console.error('❌ DEBUG: insertExperienceGroupInProduct exception:', e);
      throw e;
    }
  };
  const moveExperienceToGroupInProduct = async (productId, experienceId, groupId) => {
    try {
      let {data, error} = await supabase.rpc('move_experience_to_group_in_product', {
        arg_product_id: productId,
        arg_experience_id: experienceId,
        arg_group_id: groupId
      });
      if(data) {
        return data; 
      } else if (error) {
        throw error
      }
    } catch (e) {
      console.error(e);
    }
  };
  const moveGroupToGroupInProduct = async (groupId, targetGroupId) => {
    try {
      const { error } = await supabase.rpc('move_group_to_group_in_product', {
        arg_group_id: groupId,
        arg_target_group_id: targetGroupId,
        arg_force: false
      });
      if (error) throw error;
    } catch (e) {
      console.error(e);
      throw e;
    }
  };
  const updateExperienceGroupNameInProduct = async (name, groupId) => {
    try {
      const {data, error} = await supabase
      .from('product_experience_group')
      .update({name,})
      .eq('id', groupId)
      .select()
      .single();
      if(data) {
        return data; 
      } else if (error) {
        throw error
      }
    } catch (e) {
      console.error(e);
    }
  };
  const ungroupExperienceGroupInProduct = async (groupId) => {
    try {
      let {data, error} = await supabase.rpc('ungroup_product_experience_group', {
        arg_group_id: groupId
      });
      if(data) {
        return data; 
      } else if (error) {
        throw error
      }
    } catch (e) {
      console.error(e);
    }
  };
  const insertExperienceGroupInPersona = async (name, personaId, groupId) => {
    try {
      const {data, error} = await supabase.rpc('create_persona_experience_group', {
        arg_name: name,
        arg_persona_id: personaId,
        arg_parent_group_id: groupId
      });
      if(data) {
        return data; 
      } else if (error) {
        console.error('❌ DEBUG: insertExperienceGroupInPersona error:', error);
        throw error
      }
    } catch (e) {
      console.error('❌ DEBUG: insertExperienceGroupInPersona exception:', e);
      throw e;
    }
  };
  const moveExperienceToGroupInPersona = async (personaId, experienceId, groupId) => {
    try {
      let {data, error} = await supabase.rpc('move_experience_to_group_in_persona', {
        arg_persona_id: personaId,
        arg_experience_id: experienceId,
        arg_group_id: groupId
      });
      if(data) {
        return data; 
      } else if (error) {
        console.error('❌ [API] Error in moveExperienceToGroupInPersona:', error);
        throw error
      }
    } catch (e) {
      console.error('❌ [API] Exception in moveExperienceToGroupInPersona:', e);
      throw e;
    }
  };
  const moveGroupToGroupInPersona = async (groupId, targetGroupId) => {
    try {
      let {data, error} = await supabase.rpc('move_group_to_group_in_persona', {
        arg_group_id: groupId,
        arg_target_group_id: targetGroupId,
        arg_force: false
      });
      if(data) {
        return data; 
      } else if (error) {
        console.error('❌ [API] Error in moveGroupToGroupInPersona:', error);
        throw error
      }
    } catch (e) {
      console.error('❌ [API] Exception in moveGroupToGroupInPersona:', e);
      throw e;
    }
  };
  const updateExperienceGroupNameInPersona = async (name, groupId) => {
    try {
      const {data, error} = await supabase
      .from('persona_experience_group')
      .update({name,})
      .eq('id', groupId)
      .select()
      .single();
      if(data) {
        return data; 
      } else if (error) {
        throw error
      }
    } catch (e) {
      console.error(e);
    }
  };
  const ungroupExperienceGroupInPersona = async (groupId) => {
    try {
      let {data, error} = await supabase.rpc('ungroup_persona_experience_group', {
        arg_group_id: groupId
      });
      if(data) {
        return data; 
      } else if (error) {
        throw error
      }
    } catch (e) {
      console.error(e);
    }
  };
  const fetchUserRights = async (experienceId, profileId) => {
    try {
      let { data, error} = await supabase.rpc('fetch_user_rights_on_experience', {
        arg_experience_id: experienceId,
        arg_user_id: profileId
      });
      if(error) {
        throw error
      } else if (data) {
        return data
      }
    } catch (e) {
      console.error(e);
    }
  }
  const updateObjective = async (objective, experienceId) => {
    try {
      const result =  await supabase.from('experiences')
        .update({objective})
        .eq('id', experienceId)
        .select();
    } catch (e) {
      console.error(e);
    }
  };
  const updatePrototypeLink = async (link, experienceId) => {
    try {
      const response = await supabase.from('experiences')
        .update({prototype_link: link})
        .eq('id', experienceId);
    } catch (e) {
      console.error(e);
    }
  };
  const fetchExperiencesInPersonaAndInProductPersonaForUser =  async (personaId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_in_persona_and_in_products_persona_for_user',
        { arg_persona_id: personaId});
        if(error) {
          throw error
        } else if (data) {
          return data
        }
    } catch (e) {
      console.error(e)
    }
  };
  const fetchExperiencesInProductsAndInPersonaProductForUser =  async (productId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_in_product_and_in_persona_products_for_user',
        { arg_product_id: productId});
        if(error) {
          throw error
        } else if (data) {
          return data
        }
    } catch (e) {
      console.error(e)
    }
  };
  const fetchExperiencesNotInPersonaButInProductPersonaForUser =  async (personaId, userId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_not_in_persona_but_in_products_persona_for_user',
        { arg_persona_id: personaId});
        if(error) {
          throw error
        } else if (data) {
          return data
        }
    } catch (e) {
      console.error(e)
    }
  };
  const fetchExperiencesNotInProductButInProductPersonaForUser =  async (productId, userId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_not_in_product_but_in_persona_products_for_user',
        { arg_product_id: productId});
        if(error) {
          throw error
        } else if (data) {
          return data
        }
    } catch (e) {
      console.error(e)
    }
  };
  const fetchExperiencesNotInSharedExperience = async (sharedExperienceId, userId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_not_in_shared_experience_for_user', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_user_id: userId
      });
      if (error) {
        throw error;
      } else if (data) {
        return data;
      }
    } catch (e) {
      console.error(e);
      throw e;
    }
  };
  const fetchExperiencesByIds =  async (ids) => {
    try {
      const query = supabase.from('experiences')
        .select()
        .in('id', ids)
      const {data} = await query;
      return data;
    } catch (e) {
      console.error(e)
    }
  };
  const fetchExperiences = async (options) => {
    try {
      let experiences;
      let result;
      let query;
      if (options.personaId) {
        query = supabase.from('persona')
          .select(`
          experiences(*)
          `)
          .eq('id', options.personaId);
         if(options.productId) {
           query.eq('experiences.product_id', options.productId)
         }
         query.single();
         result = await query;
          experiences = result.data.experiences;
      } else {
        query = supabase.from('experiences')
          .select(`
           *,
           insight (id),
           persona(*)
          `);
        if(options.productId) {
          query.eq('product_id', options.productId)
        }
        result = await query;
        experiences = result.data;
      }
      return experiences;
    } catch (e) {
      console.error(e);
    }
  };
  const fetchExperiencesByProductIdAndPersonaId = async (productId, personaId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_by_product_id_and_persona_id',
        { arg_product_id: productId, arg_persona_id: personaId });
      if(error) {
        throw error
      }
      return data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  };
  const fetchExperiencesByProductId = async (productId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_by_product_id',
        { arg_product_id: productId });
      if(error) {
        console.error('❌ DEBUG fetchExperiencesByProductId - Error:', error);
        throw error
      }
      return data || [];
    } catch (e) {
      console.error('❌ DEBUG fetchExperiencesByProductId - Exception:', e);
      return [];
    }
  };
  const fetchExperienceGroupsByProductId = async (productId) => {
    try {
      let { data, error } = await supabase.rpc('get_experience_groups_by_product_id',
        { arg_product_id: productId });
      if(error) {
        console.error('❌ DEBUG fetchExperienceGroupsByProductId - Error:', error);
        throw error
      }
      return data || [];
    } catch (e) {
      console.error('❌ DEBUG fetchExperienceGroupsByProductId - Exception:', e);
      return [];
    }
  };
  const fetchExperienceGroupsByPersonaId = async (personaId) => {
    try {
      let { data, error } = await supabase.rpc('get_experience_groups_by_persona_id',
        { arg_persona_id: personaId });
      if(error) {
        console.error('❌ DEBUG fetchExperienceGroupsByPersonaId - Error:', error);
        throw error
      }
      return data || [];
    } catch (e) {
      console.error('❌ DEBUG fetchExperienceGroupsByPersonaId - Exception:', e);
      return [];
    }
  };
  const fetchExperiencesBySharedExperienceId = async (sharedExperienceId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_by_shared_experiences_id',
        { arg_shared_experiences_id: sharedExperienceId });
      if(error) {
        console.error('❌ DEBUG fetchExperiencesBySharedExperienceId - Error:', error);
        throw error
      }
      return data || [];
    } catch (e) {
      console.error('❌ DEBUG fetchExperiencesBySharedExperienceId - Exception:', e);
      return [];
    }
  };
  const fetchExperienceGroupsBySharedExperienceId = async (sharedExperienceId) => {
    try {
      let { data, error } = await supabase.rpc('get_experience_groups_by_shared_experiences_id',
        { arg_shared_experiences_id: sharedExperienceId });
      if(error) {
        console.error('❌ DEBUG fetchExperienceGroupsBySharedExperienceId - Error:', error);
        throw error
      }
      return data || [];
    } catch (e) {
      console.error('❌ DEBUG fetchExperienceGroupsBySharedExperienceId - Exception:', e);
      return [];
    }
  };
  const fetchExperiencesByPersonaId = async (personaId) => {
    try {
      let { data, error } = await supabase.rpc('get_experiences_by_persona_id',
        { arg_persona_id: personaId });
      if(error) {
        console.error('❌ DEBUG fetchExperiencesByPersonaId - Error:', error);
        throw error
      }
      return data || [];
    } catch (e) {
      console.error('❌ DEBUG fetchExperiencesByPersonaId - Exception:', e);
      return [];
    }
  };
  const fetchExperienceNotInPersona = async (personaId) => {
    try {
      let { data } = await supabase.rpc('get_experiences_not_in_persona',
        { arg_persona_id: personaId });
      return data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  };
  const fetchExperience = async (id) => {
    try {
      let { data, error} = await supabase.rpc('get_experience_by_experience_id', {
        arg_experience_id: id
      });
      if(error) {
        throw error
      }
      return data || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  };
  const fetchNumberOfPersonaAndProduct = async (experience_id) => {
    let { data, error} = await supabase.rpc('get_number_of_persona_and_product_in_experience', {
      arg_experience_id: experience_id
    });
    if(error) {
      throw error
    }
    return data || null;
  }
  const updateOrderInProduct = async (type, id, order) => {
    try {
      let {data, error} = await supabase.rpc('update_order_in_product', {
        arg_id: id,
        arg_order: order,
        arg_type: type
      });
      if(error) {
        console.error('❌ [API] Error in updateOrderInProduct:', error);
        throw error
      } else {
      }
    } catch (e) {
      console.error('❌ [API] Exception in updateOrderInProduct:', e);
      throw e;
    }
  };
  const updateOrderInPersona = async (type, id, order) => {
    try {
      let { data, error } = await supabase.rpc('update_order_in_persona', {
        arg_id: id,
        arg_order: order,
        arg_type: type
      });
      
      if(error) {
        console.error('❌ [API] Error in updateOrderInPersona:', error);
        throw error
      } else {
      }
    } catch (e) {
      console.error('❌ [API] Exception in updateOrderInPersona:', e);
      throw e;
    }
  };
  const deleteExperience = async (experienceId) => {
    try {
      await supabase
        .from('products_experiences')
        .delete()
        .eq('experience_id', experienceId);
      await supabase
        .from('experiences_persona')
        .delete()
        .eq('experience_id', experienceId);
      await supabase
        .from('insight')
        .delete()
        .eq('experience_id', experienceId);
      await supabase
        .from('experiences')
        .delete()
        .eq('id', experienceId);
    } catch (e) {
      console.error(e);
    }
  };
  const removeExperienceFromProduct = async (productExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('remove_experience_from_product', {
        arg_product_experience_id: productExperienceId
      });
      
      if (error) {
        console.error('❌ Error removing experience from product:', error);
        throw error;
      }
    } catch (e) {
      console.error('❌ Error in removeExperienceFromProduct:', e);
      throw e;
    }
  };
  const removeExperienceFromPersona = async (experiencePersonaId) => {
    try {
      const { data, error } = await supabase.rpc('remove_experience_from_persona', {
        arg_experience_persona_id: experiencePersonaId
      });
      
      if (error) {
        console.error('❌ Error removing experience from persona:', error);
        throw error;
      }
    } catch (e) {
      console.error('❌ Error in removeExperienceFromPersona:', e);
      throw e;
    }
  };
  const unlinkPersonaFromExperience = async (experienceId, personaId) => {
    try {
      await supabase
        .from('experiences_persona')
        .delete()
        .eq('experience_id', experienceId)
        .eq('persona_id', personaId);
    } catch (e) {
      console.error(e);
    }
  };
  const linkManyPersonaToExperience = async (experienceId, personaIds, groupId) => {
    try {
      let experiencesPersona = personaIds.map(p => ({
        experience_id: experienceId,
        persona_id: p
      }));
      if(groupId) {
        experiencesPersona = experiencesPersona.map(ep => ({...ep, persona_experience_group_id: groupId}) )
      }
      await supabase
        .from('experiences_persona')
        .insert(experiencesPersona).select();
    } catch (e) {
      console.error(e)
    }
  };
  const linkProductsToExperience = async (experienceId, productIds, groupId) => {
    try {
      let experienceProductList = productIds.map((id) => {
        return {'product_id': id, 'experience_id': experienceId};
      });
      if(groupId) {
        experienceProductList = experienceProductList.map(ep => ({...ep, product_experience_group_id: groupId}) )
      }
      const {data, error} = await supabase.from('products_experiences')
      .insert(experienceProductList);
      if(error) {
        throw error
      } else if (data) {
        return data
      }
    } catch (e) {
      console.error(e);
    }
  };
  const unlinkProductFromExperience = async (experienceId, productId) => {
    try {
      await supabase
        .from('products_experiences')
        .delete()
        .eq('experience_id', experienceId)
        .eq('product_id', productId);
    } catch (e) {
      console.error(e);
    }
  };
  const markAsOpened = async (personaId) => {
    try {
      try {
        const {error} = await supabase.rpc('update_item_view', {
          arg_item_id: personaId,
          arg_item_type: 'experience'
        });
        if(error) {
          throw error;
        }
      } catch (error) {
        console.error(error);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const fetchSharedExperiencesByExperienceId = async (experienceId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experiences_by_experience_id', {
        arg_experience_id: experienceId
      });
      if (error) {
        console.error('Error in getSharedExperiencesByExperienceId:', error);
        return [];
      }
      return data || [];
    } catch (e) {
      console.error('Error in getSharedExperiencesByExperienceId:', e);
      return [];
    }
  };
  const convertPersonaGroupToSharedExperience = async (personaId, groupId) => {
    try {
      const { data, error } = await supabase.rpc('convert_persona_group_to_shared_experience', {
        arg_persona_id: personaId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in convertPersonaGroupToSharedExperience:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in convertPersonaGroupToSharedExperience:', e);
      throw e;
    }
  };
  const convertProductGroupToSharedExperience = async (productId, groupId) => {
    try {
      const { data, error } = await supabase.rpc('convert_product_group_to_shared_experience', {
        arg_product_id: productId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in convertProductGroupToSharedExperience:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in convertProductGroupToSharedExperience:', e);
      throw e;
    }
  };
  return {
    searchExperiences,
    searchPersonaExperienceGroups,
    searchProductExperienceGroups,
    fetchExperience,
    fetchExperiences,
    fetchExperiencesInPersonaAndInProductPersonaForUser,
    fetchExperiencesInProductsAndInPersonaProductForUser,
    fetchExperiencesNotInPersonaButInProductPersonaForUser,
    fetchExperiencesNotInProductButInProductPersonaForUser,
    fetchExperiencesNotInSharedExperience,
    fetchExperiencesByIds,
    fetchExperiencesByProductIdAndPersonaId,
    fetchExperiencesByProductId,
    fetchExperienceGroupsByProductId,
    fetchExperienceGroupsByPersonaId,
    fetchExperienceGroupsBySharedExperienceId,
    fetchExperiencesBySharedExperienceId,
    fetchExperiencesByPersonaId,
    fetchExperienceNotInPersona,
    updateOrderInProduct,
    updateOrderInPersona,
    deleteExperience,
    insertExperience,
    insertExperienceGroupInProduct,
    moveExperienceToGroupInProduct,
    moveGroupToGroupInProduct,
    ungroupExperienceGroupInProduct,
    updateExperienceGroupNameInProduct,
    insertExperienceGroupInPersona,
    moveExperienceToGroupInPersona,
    moveGroupToGroupInPersona,
    ungroupExperienceGroupInPersona,
    updateExperienceGroupNameInPersona,
    fetchUserRights,
    updateObjective,
    linkManyPersonaToExperience,
    unlinkPersonaFromExperience,
    linkProductsToExperience,
    unlinkProductFromExperience,
    updatePrototypeLink,
    fetchNumberOfPersonaAndProduct,
    removeExperienceFromProduct,
    removeExperienceFromPersona,
    markAsOpened,
    fetchSharedExperiencesByExperienceId,
    convertPersonaGroupToSharedExperience,
    convertProductGroupToSharedExperience
  }
};
export default useExperienceApi;
